/**
 * Voice settings, one copy for the server and the widget (Гл1–Гл4, модель voice_settings).
 * The glossary is a list of words the person says aloud; the transcription prompt takes only what fits `MAX_HINT`.
 */

/** The prompt of the transcription model is short: the tail past this is dropped at a comma. */
export const MAX_HINT = 800;
export const MAX_WORD = 60;
/** The description of a project shorter than this says nothing to the prompts. */
export const MIN_CONTEXT = 20;

export interface TranscribeModelInfo {
  id: string;
  label: string;
  hint: string;
}

/** Models of /audio/transcriptions a project may pick (Гл1). */
export const TRANSCRIBE_MODELS: TranscribeModelInfo[] = [
  { id: 'gpt-4o-transcribe', label: 'gpt-4o-transcribe', hint: 'точнее, дороже' },
  { id: 'gpt-4o-mini-transcribe', label: 'gpt-4o-mini-transcribe', hint: 'быстрее, дешевле' },
  { id: 'whisper-1', label: 'whisper-1', hint: 'прежняя, простая' },
];

/** Words of a glossary text: split by comma, semicolon or a new line; trimmed, no empties, no repeats. */
export function glossaryWords(text: string): string[] {
  const seen = new Set<string>();
  const words: string[] = [];
  for (const raw of text.split(/[,;\n]+/)) {
    const word = raw.replace(/\s+/g, ' ').trim();
    const key = word.toLowerCase();
    if (word && !seen.has(key)) {
      seen.add(key);
      words.push(word);
    }
  }
  return words;
}

/** The first word past the limit, if any. */
export function longWord(words: string[]): string | null {
  return words.find((word) => word.length > MAX_WORD) ?? null;
}

export function normalizeGlossary(text: string): string {
  return glossaryWords(text).join(', ');
}

/** The fixed start of the transcription prompt. */
export const hintHead = (title: string): string => `Баг-репорт о приложении «${title}» (Jaiora)`;

/** How many words of the glossary reach the transcription prompt, given the room left after its head. */
export function hintFit(glossary: string, head: number): { total: number; used: number; room: number } {
  const room = MAX_HINT - head - 3;
  const words = glossaryWords(glossary);
  let used = 0;
  let length = 0;
  for (const word of words) {
    const next = length + (used ? 2 : 0) + word.length;
    if (next > room) break;
    length = next;
    used += 1;
  }
  return { total: words.length, used, room };
}
